export const introText =
  '<span class="intro-part">Drag the stars into the constellation that are <b>synonyms</b> for the word in the sun.</span>' +
  '<span class="intro-part">Remember, <b>synonyms</b> are words that have <b>the same meaning</b>.</span>' +
  '<span class="intro-part">Here, <b>small</b> is in the sun. <b>Little</b> and <b>tiny</b> are synonyms of the word <b>small</b>. <b>Green</b> is not.</span>';
